import React, { FC } from 'react';
import { WithStyle } from '../../../utils';
import { FormCheckboxContainer } from './container';
import { FormCheckboxIcon } from './icon';
import { FormCheckboxLabelPlan } from './label-plan';
import { FormCheckboxPlanGroupFieldProps } from './types';
import { FormCheckboxHiddenPlanItemStyled } from './hidden';
import { Text } from '../../text';
import { Col } from '@/components/ui-kit';

export const MaceFormCheckboxPlanGroupField: FC<FormCheckboxPlanGroupFieldProps> & WithStyle = ({
  m,
  mt,
  mr,
  mb,
  ml,
  p,
  pt,
  pr,
  pb,
  pl,
  ...props
}) => {
  const { value, onChange, id, className, disabled, onClick } = props;
  return (
    <FormCheckboxContainer {...{ m, mt, mr, mb, ml, p, pt, pr, pb, pl, id, className }}>
      <FormCheckboxHiddenPlanItemStyled {...{ value, onChange, disabled, onClick }} />
      <FormCheckboxLabelPlan {...props}>
        <FormCheckboxIcon />
        <Col col={12}>
          <Text as="span" fontWeight="sbold">
            {props.label}
          </Text>
        </Col>
      </FormCheckboxLabelPlan>
    </FormCheckboxContainer>
  );
};

MaceFormCheckboxPlanGroupField.defaultProps = {
  required: false,
};

MaceFormCheckboxPlanGroupField.displayName = 'FormCheckboxPlanGroupField';
